export class FinancialInstitutionClient {
  constructor(httpClient, baseURL) {
    this.httpClient = httpClient;
    this.baseURL = `${baseURL}/financial_institutions`;
  }

  async list() {
    const url = this.baseURL;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async get(id) {
    const url = `${this.baseURL}/${id}`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async put(id, params) {
    const url = `${this.baseURL}/${id}`;

    const response = await this.httpClient.request("put", url, {
      data: params
    });

    return response;
  }

  async post(params) {
    const url = this.baseURL;

    const response = await this.httpClient.request("post", url, {
      data: params
    });

    return response;
  }

  async delete(id) {
    const url = `${this.baseURL}/${id}`;

    const response = await this.httpClient.request("delete", url);

    return response;
  }
}
